<template>
  <div class="tel">
    <p v-if="message" class="errorMessage">
      {{message}}
    </p>
    <div v-if="!isSend" class="step1">
      <input type="tel" v-model="number" placeholder="09000000000">
      <div class="recaptcha" v-bind:id="'recaptcha-' + id"></div>
      <button @click="signIn">確認用SMSを送る</button>
    </div>
    <div v-else class="step2">
      <input type="number" v-model="code" placeholder="000000">
      <button @click="verifyCode">認証</button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'Signin',
  data: function () {
    return {
      message: '',
      number: '',
      code: '',
      id: '',
      isSend: false,
      recaptchaVerifier: undefined,
      recaptchaWidgetId: undefined,
      confirmationResult: undefined
    }
  },
  created: function () {
    this.id = Math.random().toString(36).substring(7)
  },
  mounted: function () {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-' + this.id)
    this.recaptchaVerifier.render().then(widgetId => {
      this.recaptchaWidgetId = widgetId
    })
  },
  methods: {
    signIn: function () {
      let appVerifier = this.recaptchaVerifier
      firebase.auth().signInWithPhoneNumber(this.number.replace(/^./, '+81'), appVerifier)
        .then(confirmationResult => {
          this.confirmationResult = confirmationResult
          this.isSend = true
        }).catch(error => {
          switch (error.code) {
            case 'auth/captcha-check-failed':
              this.message = 'reCAPTCHAが無効です'
              break
            case 'auth/invalid-phone-number':
              this.message = '電話番号のフォーマットが正しくありません。'
              break
            case 'auth/missing-phone-number':
              this.message = '電話番号が存在しません。'
              break
            case 'auth/quota-exceeded':
              this.message = 'サーバーエラー[SMSクオーター越え]'
              break
            case 'auth/user-disabled':
              this.message = 'サーバーエラー[アカウントBAN]'
              break
            case 'auth/operation-not-allowed':
              this.message = 'サーバーエラー[プロバイダが無効]'
              break
            default:
              this.message = '不明なエラー'
          }
        })
    },
    verifyCode: function () {
      this.confirmationResult.confirm(this.code).then(result => {
        this.$emit('finishAuth')
      }).catch(error => {
        switch (error.code) {
          case 'auth/invalid-verification-code':
            this.message = 'コードが違います'
            break
          default:
            this.message = '不明なエラー'
        }
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.tel{
  text-align: center;
}
.recaptcha{
  display: inline-block;
  margin: 0 auto;
}
.errorMessage{
  color: #FE4A49;
  font-size: 20px;
}
.error {
  border-color: #f00;
}
button{
  display: block;
  border:none;
  background: #02BAD2;
  font-size: 20px;
  color: #fff;
  width: 100%;
  max-width: 420px;
  height: 60px;
  margin: 10px auto 0;
  border-radius: 30px;
}
input {
  display: block;
  box-sizing: border-box;
  margin: 10px auto;
  padding: 10px;
  line-height: 1.8;
  width: 100%;
  max-width: 400px;
  font-size: 20px;
  background: #F4F4F4;
  border:none;
  text-align: center;
  border-bottom: 1px solid #999;
}
@media all and (max-width: 480px) {
  input{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/tel.vue